<template>
  <div class="download">
    <div class="top-banner">
      <div class="bibf">
        <img
          :src="$t('downLoad.bannerUrl.url')"
          :alt="$t('downLoad.bannerUrl.title')"
        />
      </div>
      <div class="title">{{ $t('downLoad.title') }}</div>
      <div class="load" @click="download">{{ $t('downLoad.name') }}</div>
    </div>
    <div class="des">
      <div class="list" v-for="item in $t('downLoad.list')" :key="item">
        {{ item }}
      </div>
    </div>
    <div class="phone-img">
      <img :src="$t('downLoad.url.url')" :alt="$t('downLoad.url.title')" />
    </div>
    <div class="model" v-if="showModal" @click.prevent="hideModal">
      <!-- <div class="tip">
        <img src="../assets/tip.png">
      </div> -->
      <div class="share-tip">
        <div class="arrow-box">
          <img src="../assets/arrow.png" />
        </div>
        <div class="tip-box">
          <img src="../assets/shareTip.png" />
        </div>
        <div class="know" @click="hideTip">我知道了</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      phoneName: '',
      showModal: false
    }
  },
  created () {
    this.phoneName = this.$route.query.phoneName
    const languageStr = this.$route.query.language
    if (languageStr) {
      if (this.$route.query.language === 'en' || languageStr.indexOf('en') !== -1) {
        this.curLanguage('en')
      } else {
        this.curLanguage('zh')
      }
    } else {
      this.curLanguage('zh')
    }
  },
  methods: {
    curLanguage (value) {
      this.$i18n.locale = value
    },
    download () {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match('micromessenger')) {
        this.judgePhone().then(() => {
          this.showModal = true
        })
      } else {
        this.judgePhone()
      }
    },
    async judgePhone () {
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      if (isAndroid === true) {
        if (this.phoneName && this.phoneName !== null) {
          // window.location.href = 'https://bibf-app.oss-cn-beijing.aliyuncs.com/app/apk/' + this.phoneName + '/bibf_android.apk'
          window.location.href = 'https://appexpo.bibf.net/app/apk/' + this.phoneName + '/bibf_android.apk'
        } else {
          window.location.href = 'https://appexpo.bibf.net/app/apk/bibf_android.apk'
        }
      } else if (isiOS === true) {
        window.location.href = 'https://apps.apple.com/cn/app/id1516206379'
      }
    },
    hideModal () {
      // this.showModal = false
    },
    hideTip () {
      this.showModal = false
    }
  }
}
</script>
<style scoped lang="stylus">
.download {
  max-width: 750px;
  margin: 0 auto;

  .top-banner {
    width: 100%;
    height: 279.5px;
    background: url('../assets/banner.png') no-repeat;
    background-size: 100% 100%;

    .bibf {
      width: 73px;
      height: 73px;
      margin: 0 auto;
      padding-top: 50px;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .title {
      margin-top: 10px;
      line-height: 25px;
      height: 25px;
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #fff;
    }

    .load {
      margin-top: 25px;
      height: 45px;
      line-height: 45px;
      width: 240px;
      font-size: 28px;
      color: #E51C24;
      background-color: #fff;
      margin: 0 auto;
      margin-top: 25px;
      border-radius: 45px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      font-size: 14px;
    }
  }

  .des {
    padding-top: 35px;

    .list {
      font-size: 19px;
      line-height: 26.5px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      text-align: center;
    }
  }

  .phone-img {
    margin-top: 10px;
    width: 100%;
    height: auto;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .model {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);

    .share-tip {
      width: 100%;
      height: 100%;
      position: relative;

      .arrow-box {
        width: 153.5px;
        height: 167px;
        position: absolute;
        top: -16px;
        right: 26.5px;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .tip-box {
        width: 192px;
        height: 58px;
        position: absolute;
        top: 138px;
        left: 92px;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .know {
        font-size: 16px;
        position: absolute;
        left: 88px;
        bottom: 217px;
        text-align: center;
        width: 199px;
        height: 48px;
        line-height: 46px;
        font-weight: 500;
        color: #fff;
        border: 1px solid #FFFFFF;
        border-radius: 100px;
      }
    }
  }
}
</style>
